import { combineReducers } from 'redux';
import createReducer from 'utils/createReducer';
import {
  ONLINE_STORE_SET_SHOPS,
  ONLINE_STORE_LOADING_PAGE_REQUEST,
  ONLINE_STORE_FINISH_PAGE_REQUEST,
  ONLINE_STORE_SET_SHOP_DETAIL,
  ONLINE_STORE_SET_SHOP_DETAIL_PRODUCTS,
  ONLINE_STORE_SHOP_DETAIL_PRODUCTS_REQUEST,
  ONLINE_STORE_SET_BUSINESS_INFO,
  ONLINE_STORE_SHOW_UPDATE_REQUIRED_MODAL,
  ONLINE_STORE_CLOSE_UPDATE_REQUIRED_MODAL,
} from 'actions/onlineStore/constants';

const shops = createReducer([], {
  [ONLINE_STORE_SET_SHOPS]: (draft, { payload }) => payload.shops,
});

const pageRequestLoading = createReducer(true, {
  [ONLINE_STORE_LOADING_PAGE_REQUEST]: () => true,
  [ONLINE_STORE_FINISH_PAGE_REQUEST]: () => false,
});

const shopDetail = createReducer(null, {
  [ONLINE_STORE_SET_SHOP_DETAIL]: (draft, { payload }) => payload,
});

const shopDetailProducts = createReducer(
  { page: 0, completed: false, data: [] },
  {
    [ONLINE_STORE_SET_SHOP_DETAIL_PRODUCTS]: (draft, { payload }) => payload,
  }
);

const shopDetailProductsRequest = createReducer(
  { status: 'ALL' },
  {
    [ONLINE_STORE_SHOP_DETAIL_PRODUCTS_REQUEST]: (draft, { payload }) => ({
      status: payload.status,
    }),
  }
);

const businessInfo = createReducer(null, {
  [ONLINE_STORE_SET_BUSINESS_INFO]: (draft, { payload }) =>
    payload.businessInfo,
});

const showUpdateRequiredModal = createReducer(false, {
  [ONLINE_STORE_SHOW_UPDATE_REQUIRED_MODAL]: () => true,
  [ONLINE_STORE_CLOSE_UPDATE_REQUIRED_MODAL]: () => false,
});

export default combineReducers({
  shops,
  pageRequestLoading,
  shopDetail,
  shopDetailProducts,
  shopDetailProductsRequest,
  businessInfo,
  showUpdateRequiredModal,
});
